import { AxiosResponse } from "axios";
import { Store } from "vuex";
import router from "@/router";
import { store } from "@/shared-store";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import {
  ICartGeolocation,
  ICartGeolocationCheckData,
} from "@/apps/merchant3/types/CartGeolocation";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const checkGeolocation = async (
  data?: ICartGeolocationCheckData
): Promise<AxiosResponse<ICartGeolocation>> => {
  const vuexStore = store as unknown as Store<IVuexState>;

  const geoLocationData = {
    merchantId: vuexStore.state.merchant?.merchant?.merchantId,
    clerkId: vuexStore.state.clerk?.clerk?.salesClerkId,
    cartId: vuexStore.state.carts?.cartId,
    cartTag: vuexStore.state.carts?.cartTag,
    userId: vuexStore.state.carts?.userId,
    currentPage: router?.currentRoute?.value?.name,
    ...data,
  };

  return await jwtApiClient.post(M3_API().CART_GEOLOCATION, geoLocationData);
};
